import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui/icons-material";
import { Box, Radio } from "@mui/material";
import ButtonLarge1 from "components/elements/ButtonLarge1";
import ContentNormal from "components/elements/ContentNormal";
import { AppContext } from "contexts/AppContext";
import { useRef, useState, useEffect, useContext } from "react";
import { translate } from "utils/Translate";

export default function SortSelect({onApply, value}) {
  const { styleGuide } = useContext(AppContext)
  const [open, setOpen] = useState(false);
  const [draftValue, setDraftValue] = useState(value);
  const rootRef = useRef(null);

  const sortOptions = [
    { value: 6, label: translate('_SHOP_SORT_NEWEST_LABEL_', 'Nyeste') },
    { value: 1, label: translate('_SHOP_SORT_POINT_LOW_HIGH_LABEL_', 'Point, lav til høj') },
    { value: 2, label: translate('_SHOP_SORT_POINT_HIGH_LOW_LABEL_', 'Point, høj til lav') },
    { value: 7, label: translate('_SHOP_SORT_POPULARITY_LABEL_', 'Mest populære') },
  ]

  useEffect(() => {
    setDraftValue(value);
  }, [value]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleApply() {
    onApply(draftValue);
    setOpen(false);
  }

  const selectedLabel = translate('_SHOP_SORT_FILTER_LABEL_', 'Sorter efter')

  return (
    <Box ref={rootRef} position={'relative'} display={'flex'}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          padding: "9px 0px",
          border: 'none',
          borderRadius: 20,
          background: "white",
          textAlign: "left",
          cursor: "pointer",
          display: 'flex',
          alignItems: 'start',
          gap: 8,
        }}
      >
        <ContentNormal>{selectedLabel}</ContentNormal>
        <Box sx={{ float: "right", marginTop: '-2px' }}>
          {open ? <KeyboardArrowUpOutlined sx={{color: styleGuide.color7}} /> : <KeyboardArrowDownOutlined sx={{color: styleGuide.color7}} />}
        </Box>
      </button>

      {open && (
        <Box
          padding={2}
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            left: -185,
            width: 300,
            background: "white",
            border: "none",
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            zIndex: 20,
          }}
        >
          <Box style={{ maxHeight: 280, overflowY: "auto" }}>
            {sortOptions.map((option) => (
              <Box
                key={option.value}
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'} paddingY={1}
                borderBottom={`1px solid ${styleGuide.color3}`}
              >
                <ContentNormal key={option.value}>
                  {option.label}
                </ContentNormal>
                <Radio
                  checked={draftValue === option.value}
                  onChange={() => setDraftValue(option.value)}
                  style={{color: draftValue === option.value ? styleGuide.color16 : ''}}
                />
              </Box>
            ))}
          </Box>

          <Box
            display={'flex'}
            gap={1}
            marginTop={2}
          >
            <ButtonLarge1
              onClick={handleApply}
              style={{ flex: 1, justifyContent: 'center' }}
              showIcon={false}
              translationKey={'_SHOP_APPLY_SORT_'}
              fallbackText={'Sortér'}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}